<template>
  <div id="head">
    <!-- 顶部通栏 -->
    <div class="container">
      <!-- Logo区域 -->
      <div class="logo">
        <!-- 使用 el-image 兼顾美观和加载效果，或者直接用 img 标签 -->
        <div class="img"></div>
        <div>泓庚航海在线练习</div>
      </div>

      <!-- 搜索区域 -->
      <div class="search-box">
        <el-input placeholder="行家专业亲授，直击就业痛点"
                  v-model="searchQuery">
          <el-select v-model="searchType"
                     slot="prepend"
                     placeholder="课程"
                     style="width: 1.3rem;">
            <el-option label="课程"
                       value="course"></el-option>
            <el-option label="讲师"
                       value="teacher"></el-option>
          </el-select>
          <el-button slot="append"
                     icon="el-icon-search"
                     type="primary">搜索</el-button>
        </el-input>
      </div>
      <!-- 用户中心 -->
      <div class="user-info">
        <div class="service-btn" @click="global.customerShow = true">在线客服</div>
        <!-- 消息图标 -->
        <div class="msg-btn"></div>
        <!-- 头像和欢迎语 -->
        <div class="user-avatar">
          <div class="img"></div>
          <!-- <span class="welcome-text" @click="goLogin">{{ userName }}</span> -->
          <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" >
            <el-dropdown-item icon="el-icon-plus"
            v-if="!global.user"
            command="login"
            @click="goLogin">登录</el-dropdown-item>
            <el-dropdown-item icon="el-icon-plus"
            v-if="global.user"
            command="logout"
            @click="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        </div>
      </div>
    </div>

    <!-- 主导航栏 -->
    <div class="main-nav">
      <el-menu :default-active="activeRoute"
               mode="horizontal"
               @select="handleSelect">
        <el-menu-item index="Home">首页</el-menu-item>
        <el-menu-item index="course">课程分类</el-menu-item>
        <!-- <el-menu-item index="myCourses">我的课程</el-menu-item> -->
        <!-- <el-menu-item index="4">在线客服</el-menu-item> -->
        <el-menu-item index="orderForm" v-if = "global.user" @click.native="goOrderForm"> 个人中心</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { Global } from "@/global";
import * as req from "@/utils/request";
export default {
  name: 'HgOnlineHead',

  data() {
    return {
      searchType: 'course',
      searchQuery: ''
    }
  },
  computed: {
    userName() {
      let user = window.$global.user
      if (!user || !user.sysUser) {
        return '游客'
      }
      return '你好,' + user.sysUser.nickName
    },
    activeRoute() {
      return window.$global.activeRoute
    }
  },
  mounted() {},

  methods: {
    handleCommand(command) {
      if (command === 'login') {
        this.goLogin()
      }
      if (command === 'logout') {
        this.logout()
      }
    },
    goLogin() {
      window.$global.isLogin = true
    },
    logout() {
      this.$confirm('确定退出当前账号吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let sendData = {}
        sendData.data = null
        sendData.fn = this.doLogoutFn
        sendData.vm = this
        req.Get('logout', sendData)
      }).catch(() => {
      });
      // window.localStorage.removeItem("Authorization")
      // window.location.reload()
    },
    doLogoutFn(data) {
      window.localStorage.removeItem('Authorization')
      this.$message.success('退出成功')
      this.$router.push('/')
      window.location.reload()
      
    },
    goOrderForm() {
      window.$global.activeRoute = 'orderForm'
      this.$router.push('/orderForm')
    },
    handleSelect(key) {
      if (key === 'myCourses') {
        window.$global.activeRoute = key
        this.$router.push({ path: '/myCourses' })
      }
      if (key === 'Home') {
        window.$global.activeRoute = key
        this.$router.push('/')
      }
      if (key === 'course') {
        window.$global.activeRoute = key
        this.$router.push('/course')
      }
      if (key === 'orderForm') {
        this.goOrderForm()
      }
    }
  }
}
</script>

<style scoped>
#head {
  width: 100%;
  height: 100%;
}
/* 通用容器宽度 */
.container {
  width: 100%;
  height: 70%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}

/* Logo 样式 */
.logo {
  display: flex;
  align-items: center;

  font-weight: 500;
  color: #333333; /* 保持和搜索按钮一样的蓝色 */
}
.logo > .img {
  width: 0.5rem;
  height: 0.5rem;
  margin-left: 0.5rem;
  background: url('@/assets/head/logo.png') no-repeat;
  background-size: 100% 100%;
  margin-right: 0.1rem;
}
.logo > div {
  font-size: 0.3rem;
}
/* 搜索框样式 */
.search-box {
  flex: 1;
  display: flex;
  max-width: 8rem;
}
/* 修正 Element UI 样式覆盖 */
.search-box ::v-deep .el-input-group__prepend {
  background-color: #fff; /* 白色背景 */
  border-right: none;
  padding: 0 0.2rem;
  border-radius: 0.4rem 0 0 0.4rem; /* 只保留左边圆角 */
  border-right: none;
}

/* 设置下拉框内部文本颜色和placeholder颜色 */
.search-box ::v-deep .el-input-group__prepend .el-input__inner {
  color: #000; /* 正常文本黑色 */
  border: none; /* 移除内部边框 */
}

/* 修改 placeholder 字体颜色 */
.search-box ::v-deep .el-input-group__prepend .el-input__inner::placeholder {
  color: #000000; /* 设置placeholder颜色为灰色 */
}

/* 对于旧版浏览器兼容 */
.search-box
  ::v-deep
  .el-input-group__prepend
  .el-input__inner::-webkit-input-placeholder {
  color: #000000;
}
.search-box
  ::v-deep
  .el-input-group__prepend
  .el-input__inner::-moz-placeholder {
  color: #000000;
}
.search-box
  ::v-deep
  .el-input-group__prepend
  .el-input__inner:-ms-input-placeholder {
  color: #000000;
}

.search-box ::v-deep .el-input-group__append .el-button {
  background-color: #0059ab; /* 蓝色背景 */
  color: #fff;
  border: none;
  border-radius: 0 0.4rem 0.4rem 0; /* 只有右边圆角 */
  height: 0.5rem; /* 让按钮高度占满父容器 */
  margin: 0;
  padding: 0 0.2rem; /* 调整内部间距 */
}

/* 确保输入框和按钮在同一水平线上 */
.search-box ::v-deep .el-input__inner {
  border-left: none;
  height: 0.5rem; /* 输入框高度占满 */
}

.search-box ::v-deep .el-input-group__append {
  border: none !important;
  padding: 0;
}

.search-box ::v-deep .el-input__icon {
  line-height: 0.1rem;
}

/* 用户信息样式 */
.user-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.2rem;
  padding-right: 0.5rem;
}
.msg-btn {
  width: 0.2rem;
  height: 0.2rem;

  background: url('@/assets/head/inform.png') no-repeat;
  background-size: 100% 100%;
}
.user-avatar {
  display: flex;
  align-items: center;
}
.user-avatar > .img {
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  margin-right: 0.1rem;
  margin-left: 0.1rem;
  cursor: pointer;
  background: url('@/assets/head/user.png') no-repeat;
  background-size: 100% 100%;
}
.welcome-text {
  color: #333;
}

/* 2. 主导航栏样式 */
.main-nav {
  background-color: #ffffff;
  height: calc(100% - 70%);
  padding-left: 10vw;
  padding-bottom: 0.2rem;
}
.main-nav .container {
  padding: 0;
}

/* 修正导航菜单的边框和背景 */
.main-nav ::v-deep .el-menu {
  border-bottom: none;
  background-color: transparent;
}
.main-nav ::v-deep .el-menu-item {
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.2rem;
  color: #333;
}
/* 首页按钮特殊样式（蓝色背景） */
.main-nav ::v-deep .el-menu-item.is-active {
  background-color: #0059ab;
  color: #fff;
}
/* 普通菜单项 hover 效果 - 不包括已激活的项 */
.main-nav ::v-deep .el-menu-item:not(.is-active):hover {
  background-color: #dadada !important; /* 悬停时的背景色 */
  color: #333 !important; /* 悬停时的字体颜色 */
}

/* 保持激活状态的 hover 效果 - 不做任何改变 */
.main-nav ::v-deep .el-menu-item.is-active:hover {
  background-color: #0059ab !important; /* hover 时保持原来的激活颜色 */
  color: #fff !important; /* hover 时保持原来的激活文字颜色 */
}
.search-btn {
  border-radius: 0 0.4rem 0.4rem 0 !important;
}
.service-btn {
  font-weight: 500;
  color: #333333;
  font-size: 0.2rem;
  margin-right: 0.5rem;
  cursor: pointer;
}
</style>